import { render, staticRenderFns } from "./RoomDrawingContainer.vue?vue&type=template&id=6d620ca0&"
import script from "./RoomDrawingContainer.vue?vue&type=script&lang=js&"
export * from "./RoomDrawingContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports